type ThumbIconProps = {
 active?: boolean
 color?: string
 rotate?: boolean
}

const ThumbIcon = ({
 active = false,
 color = '#16A34A',
 rotate = false,
}: ThumbIconProps) => {
 return (
  <svg
   xmlns='http://www.w3.org/2000/svg'
   width='20'
   height='20'
   viewBox='0 0 24 24'
   className={
    rotate ? 'rotate-180 transition' : 'transition'
   }
  >
   <path
    d='M2 21h4V9H2v12zm20-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L13.17 1 7.59 6.59C7.22 6.95 7 7.45 7 8v12c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1z'
    fill={active ? color : '#C5CED6'}
   />
  </svg>
 )
}

export default ThumbIcon
